import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';

interface RatingQuestionProps {
  id: number;
  value: number;
  onChange: (value: number) => void;
  isRequired: boolean;
  disabled?: boolean; 
}

export const RatingQuestion: React.FC<RatingQuestionProps> = React.memo(({ 
  id, 
  value, 
  onChange,
  isRequired,
  disabled
}) => {
  const currentRating = value || 0;

  return (
    <div className="rating-container">
      <input 
        type="number"
        min="1"
        max="5"
        value={currentRating}
        onChange={(e) => onChange(Number(e.target.value))}
        required={isRequired}
        className="rating-hidden-input"
        style={{ opacity: 0, position: 'absolute', pointerEvents: 'none' }}
        disabled={disabled}
      />
      {[1, 2, 3, 4, 5].map((rating) => (
        <button
          key={rating}
          type="button"
          className="star-btn"
          onClick={() => onChange(rating)}
          aria-label={`Rate ${rating} stars`}
          disabled={disabled}
        >
          <FontAwesomeIcon 
            icon={rating <= currentRating ? faStarSolid : faStarRegular}
            className={rating <= currentRating ? 'star-filled' : 'star-empty'}
          />
        </button>
      ))}
    </div>
  );
});

RatingQuestion.displayName = 'RatingQuestion';